<template>
    <div>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-text class="std-padding">
                    <h5>{{ text }}</h5>
                </v-card-text>
        
                <v-divider class="margin0" />
        
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" flat @click="dialog = false">Cancel </v-btn>
                    <v-btn color="primary" flat @click="deleteItem()">Yes </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    data () {
        return {
            dialog: false,
            text: "Are you sure to delete the item ?",
            id: "",
            name: "",
            link: "",
        };
    },
    mounted () {
        var self = this;
        EventBus.$on("deleteDialog", function (object) {
            self.dialog = true;
            self.text = object.text;
            self.id = object.id;
            self.name = object.name;
            self.link = object.link;
        });
    },
    methods: {
        deleteItem() {
            this.dialog = false;
            this.confirmDeleteTableItem(this.id, this.name, this.link);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/buttons/DeleteDialog.vue